import { render, staticRenderFns } from "./SurveyPageFooter.vue?vue&type=template&id=b4c799a4&"
import script from "./SurveyPageFooter.vue?vue&type=script&lang=ts&"
export * from "./SurveyPageFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports